import { AppTask, IContainer } from 'aurelia';
import { IRouterEvents } from '@aurelia/router';
import { SessionStorage } from './services/storage';

const fetchedAgain = 'page-fetched-again';

// Every page and every form has a script of its own, with a name that changes with each build. A tab that was
// opened before a deploy asks for a script that is gone: the page it was on its way to never opens, or it opens
// with an empty form. The browser then fetches the page from the server, which starts the new build. It does so
// once for a page, until another page has opened, so a script that is gone for another reason does not make the
// page load itself for ever.
export const FetchThePageAgainWhenAScriptIsGone = AppTask.creating(IContainer, (container) => {
  const events = container.get(IRouterEvents);
  const storage = container.get(SessionStorage);
  let navigating = false;
  let scriptIsGone = false;
  let leaving = false;

  const here = () => window.location.pathname + window.location.search;

  function fetchAgain(page) {
    if (leaving || storage.getItem(fetchedAgain) === page) return;
    leaving = true;
    storage.setItem(fetchedAgain, page);
    if (page === here()) window.location.reload();
    else window.location.assign(page);
  }

  // A form is loaded after the navigation to its page has ended, so its script can be gone on a page that opened.
  window.addEventListener('vite:preloadError', () => {
    scriptIsGone = true;
    if (!navigating) fetchAgain(here());
  });

  events.subscribe('au:router:navigation-start', () => {
    navigating = true;
    scriptIsGone = false;
  });
  events.subscribe('au:router:navigation-cancel', () => {
    navigating = false;
  });
  events.subscribe('au:router:navigation-error', (event) => {
    navigating = false;
    const query = event.instructions.queryParams.toString();
    if (scriptIsGone) fetchAgain(`/${event.instructions.toPath()}${query ? `?${query}` : ''}`);
  });
  events.subscribe('au:router:navigation-end', () => {
    navigating = false;
    if (scriptIsGone) fetchAgain(here());
    else if (!leaving && storage.getItem(fetchedAgain) !== here()) storage.removeItem(fetchedAgain);
  });
});
